module.exports = "https://health.dajiuxing.com.cn/img/assets/serviceImg/ksfw1.png"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=assets%2FserviceImg%2Fksfw1.png
// module id = iaTl
// module chunks = 93